/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-06-05 10:57:29
 * @LastEditors: linxi
 * @LastEditTime: 2025-07-22 16:00:31
 */

import { API_PREFIX } from './constant'
import { Request } from './request'

// 列表
export interface TAHLocationListParams {
  current?: any
  size?: any
  tenantId?:any
}

export function getTAHLocationList(
  params: TAHLocationListParams
): Request {
  return {
    url: `${API_PREFIX}/blade-store/temperaturehumiditylocal/list`,
    method: 'GET',
    params,
  }
}

export interface DetailParams {
  id?: any
  tenantId?: any
}
// 详情
export function getTAHLocationDetail(params: DetailParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/temperaturehumiditylocal/detail`,
    method: 'GET',
    params
  }
}


// 保存编辑
export interface SubmitParams {
  id?: any
  humidityRangHight	?: any
  humidityRangLow?: any
  local?: any
  type?:any
  temperatureRangHight?: any
  temperatureRangLow?: any
}

export function getTAHLocationSubmit(body: SubmitParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/temperaturehumiditylocal/submit`,
    method: 'POST',
    body,
  }
}

// 删除
export function getRemove(ids: any): Request {
  return {
    url: `${API_PREFIX}/blade-store/temperaturehumiditylocal/remove`,
    method: 'GET',
    params: {
      ids,
    },
  }
}
